import { get as getRequest } from 'axios'
import u from 'umbrellajs'
import { createEvent } from './GoogleAnalytics'

// Main Export
function GoogleAnalyticsTracking() {
  u(document).on('ready', function(){
    // Track Click Events
    u('.track').on('mousedown', trackClick)

    // Send a get request to every *[data-record-hit]
    // @FIXME: Should we lock this down a bit? Seems like an XSS vuln
    u('*[data-record-hit]').map(el => getRequest(u(el).data('record-hit')))

    // Social Events
    u('.facebook-share').on('click', sendSocialEvent('facebook', 'share'))
    u('.twitter-share').on('click', sendSocialEvent('twitter', 'share'))

    // Finda Events
    u('*[data-ad-tracking]')
      .map(el => JSON.parse(u(el).data('ad-tracking')))
      .map(adTracking => sendFindaEvent(adTracking))

    u('.advertiserTrack').on('click', function(){
      sendFindaEvent(getAdData(this), 'advertiser-page_click', 'click_action')
    })

    // @TODO: this won't handle keyboard enter submit event
    u('#adContactForm button[type="submit"]').handle('click', function(event){
      sendFindaEvent(getAdData(this), 'contact_clicktocall', 'click_action', function(){
        u(event.target).closest('form').trigger('submit')
      })
    })
    u('.classifiedsApp .listingRight .advertiser-logo a').on('click', function(){
      sendFindaEvent(getAdData(this), 'advertiser_search', '')
    })
  })
}

// Module exports
export const trackAdvertiserContactClick = el => sendFindaEvent(getDealerData(el), 'contact_clicktoshow', 'click_action')
export const trackPhoneClick = el => sendFindaEvent(getDealerData(el), 'phone_clicktocall', 'click_action')
export const trackWebsiteClick = el => sendFindaEvent(getDealerData(el), 'website_clicktocall', 'click_action')
export const trackShortListClick = el => {
  let $el = u(el).closest('[data-ad-tracking]')
  if($el.length === 0){ $el = u('*[data-ad-tracking]').first() }
  sendFindaEvent(getAdData($el), 'shortlist', false)
}

// AdData Selectors
const getAdData = el => JSON.parse(u(el).closest('*[data-ad-tracking]').data('ad-tracking'))

const getDealerData = (el) => {
  const data = getAdData(el)
  if(u(el).data('dealer-event')){ return data }
  const dealerData = JSON.parse(u('*[data-dealer-tracking]').first().data('dealer-tracking'))
  data.ad_id = dealerData.dealer_id
  data.ad_name = dealerData.dealer_name
  data.ad_address = dealerData.dealer_address
  return data
}

// Send helpers for dispatching GoogleAnalytics events
const sendTrackEvent = ({ category, action, label, value }) => createEvent({
  tracker: 'send',
  hitType: 'event',
  token: 'trackEvent',
  category,
  action,
  label,
  value,
})

const sendSocialEvent = ( socialNetwork, socialAction, socialTarget = window.location.href ) => createEvent({
  tracker: 'send',
  hitType: 'social',
  token: 'socialEvent',
  socialNetwork,
  socialAction,
  socialTarget,
})

const sendFindaEvent = (data, eventType, clickAction, hitCallback) => createEvent({
  tracker: 'findaTracker.send',
  hitType: 'event',
  token: 'findaEvent',
  network: 'lc',
  event_type: eventType || data.event_type,
  click_action: clickAction || data.click_action,
  hitCallback: hitCallback || data.hitCallback,
  data,
})

// Handles universal .track clicks
function trackClick(el) {

  // Is this a click event?
  if(el instanceof Event && el.type === 'click' && el.target){ el = el.target }
  // Ensure we have a valid element to work with
  if(!(el instanceof Element)){ return console.error('Invalid node for tracking!!') }

  // Search up the tree for an overlay node, if we can't find one defualt to the parent node
  const $el = u(el)
  const $container = $el
        .parent('*[data-overlay-marker]')
        .map(element => {
          const marker = JSON.parse(u(el).data('overlay-marker'))
          return ['container', 'page', 'fragment'].includes(marker.content_type) ? element : null
        })
        .filter(element => element) // Not Null
        .first() || u(el.parentNode) // Closest match or parent

  // Parse Data attributes
  const nodeData = $el.data()
  const overlayData = JSON.parse($container.data('overlay-marker'))
  const trackingData = JSON.parse(nodeData.track)

  // Construct and send the event
  return sendTrackEvent({
    label: trackingData.label || overlayData.label || nodeData.label || '',
    category: trackingData.category || overlayData.label || overlayData.content_type || location.href,
    action: trackingData.action || 'click',
    value: nodeData.value ? parseInt(nodeData.value, 10) : undefined
  });
}

export default {
  init: GoogleAnalyticsTracking,
  track_advertisercontactclick: trackAdvertiserContactClick,
  track_phoneclick: trackPhoneClick,
  track_shortlist: trackShortListClick,
  track_websiteclick: trackWebsiteClick,
}
